var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function makeSystem(filter, run, phase) {
    if (phase === void 0) { phase = 'step'; }
    return function (game) {
        var query = game.queryManager.create(filter);
        function onPhase() {
            var e_1, _a;
            var ent;
            try {
                for (var query_1 = __values(query), query_1_1 = query_1.next(); !query_1_1.done; query_1_1 = query_1.next()) {
                    ent = query_1_1.value;
                    run(ent, game);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (query_1_1 && !query_1_1.done && (_a = query_1.return)) _a.call(query_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        game.on(phase, onPhase);
        return function () {
            game.off(phase, onPhase);
        };
    };
}
//# sourceMappingURL=System.js.map